<template>
  <Breadcrumbs main="Categoría" title="Fases" />
  <div class="container-fluid">
    <div class="row project-cards">
      <TopMenu @reload-list="loadItems" :phaseId="phaseId" />
      <Table :list="list" :phaseId="phaseId" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import axios from "@/includes/connection";

import TopMenu from "./components/TopMenu.vue";
import Table from "./components/Table.vue";
import { useRoute } from "vue-router";

const route = useRoute();
const phaseId = route.params.id;

const list = ref([]);

onMounted(() => {
  loadItems();
});

function loadItems() {
  axios
    .get("/phases")
    .then((response) => {
      console.log("loadItems", response.data);
      list.value = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
}
</script>
